<template>
  <roe-error-message :field="tier.applicable_year">
    <input type="number" disabled v-model="tier.$model.applicable_year" />
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";

export default {
  name: "RoeTierApplicableYearInput",
  components: { RoeErrorMessage },
  props: {
    tier: Object,
    value: Number
  },
  // TODO: FIX
  mounted() {
    this.tier.$model.applicable_year = this.value;
  },
  created() {
    this.tier.$model.applicable_year = this.value;
  }
};
</script>
